import Android1 from './images/Android_1_150_LT.png';
import Android2 from './images/Android_Dodaj_150_LT.png';
import Ios1 from './images/IOS_1_150_LT.png';
import Ios2 from './images/IOS_Dodaj_150_LT.png';
import Last from './images/ios_android_3.png';

import VolumeUp from './images/dailyTutorial/volume-up.svg';
import HandsUp from './images/dailyTutorial/hand-up.svg';
import VolumeUpBlank from './images/dailyTutorial/volume-up-blank.svg';
import TranslationBlank from './images/dailyTutorial/icon-translate-blank.svg';
import HintBlank from './images/dailyTutorial/idea-blank.svg';
import InfoBlank from './images/dailyTutorial/information-blank.svg';
import GreenCircle from './images/dailyTutorial/green-circle.svg';
import YellowCircle from './images/dailyTutorial/yelow-circle.png';
import Microphone from './images/dailyTutorial/icon-microphone.svg';
import ScreenOne from './images/dailyTutorial/samouczek_czat_1.png';
import ScreenTwo from './images/dailyTutorial/samouczek_czat_2.png';
import ScreenThree from './images/dailyTutorial/samouczek_czat_3.png';
import ScreenFour from './images/dailyTutorial/samouczek_czat_4.png';
import Tutorial from './images/dailyTutorial/samouczek-fiolet.svg';

import Micro from './images/wordTrainerTutorial/icon-microphone.png';
import Voice from './images/wordTrainerTutorial/volume-up.svg';
import Person from './images/wordTrainerTutorial/user.svg';

export default {
	passwordRestart: {
		title: 'Slaptažodžio atkūrimas',
		password: 'Slaptažodis',
		repeatPassword: 'Pakartokite slaptažodį',
		restartPawssord: 'Slaptažodžio atkūrimas',
	},
	paywall: {
		title: 'Pasirinkite planą, kad galėtumėte tęsti mokymąsi',
		buy: 'Pirkti',
		savePayment: 'Saugus mokėjimas šiais būdais',
		skip: 'Praleisti',
		pickPlan: 'Pasirinkti planą',
		endPlanFirstPart: 'Tavo prieiga baigsis po',
		endPlanSecondPart: 'dienų.',
		endPlanAditionalPart: 'dienų.',
		paymentTitle: 'Santrauka',
		product: 'Produktas:',
		plan: 'SynthiAi paketas',
		forLong: 'Prieiga laikotarpiui',
		data: 'duomenys:',
		nameAndSurname: 'Vardas ir pavardė:',
		paymentForm: 'Mokėjimo būdas:',
		toPay: 'Mokėti šiandien:',
		accept: 'Sutinku su',
		rules: 'taisyklių sąlygomis',
		payingAccept: 'Sutikdami su mokėjimu, jūs sutinkate su',
		paymentRules: '"PayU mokėjimo sąlygomis"',
		buyAndPay: 'PERKU IR MOKU',
	},
	paymentStatus: {
		veryfication: 'Mokėjimas vis dar apdorojamas...',
		title: 'Mokėjimas baigtas',
		success: 'Sėkminga!',
		failure: 'Nepavyko!',
		subtitle: 'Netrukus būsite nukreipti į prisijungimo puslapį.',
		textInfo:
			'Jūsų mokėjimas buvo sėkmingai apdorotas. Dabar galite nustatyti savo slaptažodį mūsų registracijos puslapyje. Per kelias minutes gausite el. laišką su nuoroda slaptažodžiui nustatyti. Patikrinkite savo pašto dėžutę ir šlamšto aplanką. Kad paieška būtų lengvesnė, įveskite "synthiai". Jei kiltų problemų, susisiekite su mumis el. paštu: contact@synthiaiapp.com',
		login: 'Prisijungti',
	},
	register: {
		steps: {
			register: 'Registracija',
			package: 'Paketas',
			summarize: 'Santrauka',
			step: 'Žingsnis ',
		},
		stepOne: {
			password: 'Slaptažodis',
			errorGoogle: 'Prisijunkite naudodami savo el. pašto adresą',
			title: 'Registracija',
			nameAndSurname: 'Vardas ir pavardė',
			placeholderNameAndSurname: 'XXXXXXXXXXX',
			email: 'El. pašto adresas',
			placeholderEmail: 'pvz. pelda@synthiaiapp.com',
			password: 'Slaptažodis',
			start: 'SUKURTI PASKYRĄ',
			subtitle:
				'Slaptažodis turi būti bent 8 simbolių ilgio, turėti didžiųjų ir mažųjų raidžių bei bent vieną skaičių.',
			passwordError1: 'Slaptažodis turi būti bent 8 simbolių ilgio.',
			passwordError2: 'Slaptažodyje turi būti bent viena didžioji raidė.',
			passwordError3: 'Slaptažodyje turi būti bent viena mažoji raidė.',
			passwordError4: 'Slaptažodyje turi būti bent vienas skaičius.',
			passwordError5: 'Slaptažodžiai turi sutapti.',
		},
		stepTwo: {
			title: 'Pasirinkti planą',
			month: 'mėnuo',
			months: 'mėnesiai',
			months2: 'mėnesių',
			value: '€ / mėn.',
			pick: 'pasirinkti',
			nowPay: 'Mokėjimas dabar',
			saveOne: 'Sutaupykite',
			buy: 'Pirkti',
			savePayment: 'Saugus mokėjimas šiais būdais',
		},
		stepThree: {
			title: 'Santrauka',
			product: 'Produktas:',
			plan: 'Synthi AI paketas',
			forLong: 'Prieiga:',
			data: 'data:',
			nameAndSurname: 'Vardas ir pavardė:',
			paymentForm: 'Mokėjimo būdas:',
			toPay: 'Mokėtina:',
			accept: 'Sutinku su',
			rules: 'taisyklių sąlygomis',
			payingAccept: 'Sutikdamas su mokėjimu, sutinku su',
			paymentRules: '"PayU mokėjimo sąlygomis"',
			buyAndPay: 'PIRKTI IR MOKĖTI',
		},
	},
	succesPayment: {
		title: 'Mokėjimas sėkmingas!',
		subtitle: 'Netrukus būsite nukreiptas į prisijungimo puslapį.',
	},
	firstLogin: {
		createPasswordForAcoount: 'Sukurkite slaptažodį savo paskyrai',
		typeEmail: 'Įveskite el. pašto adresą',
		useSameEmail: 'Naudokite tą patį el. pašto adresą, kurį nurodėte pirkdami',
		typePassword: 'Įveskite slaptažodį',
		confirmPassword: 'Patvirtinkite slaptažodį',
		createPassword: 'Sukurti slaptažodį',
		errorLogin: 'Patikrinkite, ar teisingas jūsų slaptažodis arba el. paštas',
		createdPassword: 'Jau sukūrėte slaptažodį?',
		clickToLogin: 'Spustelėkite čia norėdami prisijungti',
	},
	login: {
		dontHavePassword: 'Neturite slaptažodžio?',
		getPassword: 'Spustelėkite čia, kad gautumėte prieigą',
		title: 'Prisijungimas',
		email: 'El. pašto adresas',
		password: 'Slaptažodis',
		textSub: 'Pamiršote slaptažodį? Atkurti',
		restart: 'čia',
		restartPasswordText:
			'Įveskite savo el. pašto adresą, kad atkurtumėte slaptažodį. Slaptažodis bus išsiųstas į jūsų gautųjų pašto dėžutę.',
		placeholder: 'įveskite savo el. pašto adresą...',
		resetPassword: 'slaptažodžio atkūrimas',
		buttonText: 'Prisijungti',
		errorLogin: 'Patikrinkite savo el. pašto adresą ir slaptažodį.',
		passwordResterted:
			'Jūsų slaptažodis atkurtas. Patikrinkite savo el. paštą.',
		passwordError: 'Deja, jūsų el. pašto adresas nerastas.',
		mobileAppBannerText: 'Atraskite mūsų programėlę!',
	},
	navBar: {
		home: 'Pagrindinis',
		learn: 'Mokytis',
		profile: 'Profilis',
	},
	home: {
		hello: 'Labas',
		question: 'Apie ką norėtum šiandien pasikalbėti?',
		answer: 'Pradėk pokalbį',
		forYou: 'Rekomenduojama tau',
		popularNow: 'Šiuo metu populiaru',
		doYouKnow: 'Ar žinojai, kad...?',
		funFact: 'Šiandienos įdomus faktas',
		new: 'Nauja',
		check: 'Patikrink',
		yourFavorite: 'Tavo mėgstamiausi',
		newTitle: 'Žodžių treneris',
		newSubtitle: 'Praktikuok žodžių tarimą',
		talkWith: 'Kalbėk bet kuria tema su',
		photoConversation: {
			photoConversationMode: 'Nuotraukų pokalbio režimas',
			goToChatTakeAPhoto:
				'Atverk pokalbį, nufotografuok arba pasirink iš galerijos ir kalbėk apie tai.',
			check: 'Patikrink',
			new: 'Nauja',
		},
	},
	learn: {
		wordTrainer: {
			title: 'Žodžių treneris',
			subtitle: 'Praktikuok žodžių tarimą',
			new: 'Nauja',
		},
		flashcardV2: {
			new: 'Nauja',
			sport: 'Sportas',
			continue: 'tęsti',
			nice: 'Puiku!',
			congratulation: 'Sveikiname!',
			category: 'Kategorija',
			textAfterCategory: 'tau ne paslaptis!',
			pickNewCategory: 'Pasirink naują kategoriją',
			showResult: 'Rodyti sprendimą',
			createWordWithLetters: 'Sukurk žodį iš maišytų raidžių',
			know: 'Žinau',
			dontKnow: 'Nežinau',
			metchWords: 'Sujunk poromis',
			addNewCategory: 'Pridėti naują kategoriją',
			personalizeLearning: 'Priderink mokymąsi susikūręs savo kategoriją.',
			typeNewCategory: 'Įvesk savo kategorijos pavadinimą',
			save: 'Išsaugoti',
			weAreCreatingCategoryForYou: 'Kuriame tau naują kategoriją:',
			start: 'PRADĖTI',
			howToUseFlashcard: 'Kaip naudotis kortelėmis?',
			knowFlashcard:
				'Paspausk „Nežinau“ arba „Žinau“, kad įvertintum savo žinias.',
			dontKnowFlashcard: 'Kortelės, pažymėtos „Žinau“, daugiau nebesikartos.',
			clickToHear: 'Paspausk, kad išgirstum žodį.',
			clickForDefinition: 'Paspausk, kad pamatytum apibrėžimą',
			clickForTranslation: 'Paspausk, kad pamatytum vertimą ir pavyzdžius',
			close: 'Uždaryti',
			clickCategoryToStart:
				'Spustelėk pasirinktos kategorijos pavadinimą, kad pradėtum mokymąsi.',
			lookAsProgressBar:
				'Progreso juosta po kategorija rodo, kiek žodžių jau išmokai.',
			clickToSetupFavaroiteFlashcard:
				'Spustelėk, kad nustatytum kategoriją kaip mėgstamą.',
			clickToCreateOwnCategory:
				'Spustelėk, kad sukurtum savo kortelių kategoriją.',
			howLearningLookLike: 'Kaip atrodo mokymasis?',
			restText:
				' Mokymasis susideda iš kortelių peržiūros ir žinių įvertinimo. Taip pat atliksi paprastas užduotis.',
		},
		chat: {
			title: 'Pokalbis',
			subtitle: 'Kalbėk bet kuria tema.',
		},
		fotoMode: {
			title: 'Atspėk nuotrauką',
			subtitle: 'Apibūdink nuotrauką kuo tiksliau.',
		},
		scene: {
			title: 'Scenos',
			subtitle: 'Vaidink kartu su AI mokytoju.',
		},
		word: {
			title: 'Žodžiai',
			subtitle: 'Praturtink savo žodyną.',
		},
		flashcard: {
			title: 'Kortelės',
			subtitle: 'Kartok ir įsimink žodžius su kortelėmis.',
		},
		seeMore: 'Peržiūrėti visus',
	},
	common: {
		description:
			'SynthiAi – tavo išmanus anglų kalbos mokymosi asistentas. Mokykis anglų kalbos sklandžiai su dirbtinio intelekto pagalba. Atrask naują ir veiksmingą kalbų mokymosi metodą. Pradėk jau šiandien!',
		deletedFromFavorite: 'Pašalinta iš mėgstamiausių',
		addedToFavorite: 'Pridėta prie mėgstamiausių',
		flashcards: 'Kortelės',
		flashcards_v2: 'Kortelės',
		scenes: 'Scenos',
		scenes_v3: 'Scenos',
		words: 'Žodžiai',
		privacyLink: 'privatumas',
		termsLink: 'taisykles',
		or: 'arba',
		continueWithFB: 'Tęsti su Facebook',
	},
	profile: {
		days: [
			'Pirmadienis',
			'Antradienis',
			'Trečiadienis',
			'Ketvirtadienis',
			'Penktadienis',
			'Šeštadienis',
			'Sekmadienis',
		],
		top: {
			profile: 'Profilis',
			accessTo: 'Prieiga:',
			profileImage: 'Profilio nuotrauka',
			nameAndSurname: 'Vardas ir pavardė',
			password: 'Slaptažodis',
			change: 'Keisti',
			changeProfileImage: 'Keisti profilio nuotrauką',
			changeNameAndSurname: 'Keisti vardą ir pavardę',
			changeNameAndSurnamePlaceHolder: 'Įvesk savo vardą',
			save: 'Išsaugoti',
			changePassword: 'Keisti slaptažodį',
			passwordInfo:
				'Slaptažodis turi būti bent 8 simbolių ilgio, turėti didžiųjų ir mažųjų raidžių bei vieną skaičių.',
			repeatPassword: 'Pakartokite slaptažodį',
			passwordChanged: 'Slaptažodis pakeistas',
			error: 'Oi, kažkas negerai',
			nameChanged: 'Vardas pakeistas',
			profileChanged: 'Profilis pakeistas',
		},
		plan: {
			yourPlan: 'Tavo planas',
			extend: 'Pratęsti planą',
			short_extend: 'Pratęsti',
			currentPlan: 'Dabartinis planas:',
			activeToPlan: 'Aktyvus iki:',
			currentPlanLong: 'Tavo dabartinis planas',
		},
		middle: {
			yourMedals: 'Tavo pasiekimai',
			oneDay: 'diena',
			twoDays: 'dienos',
			words: 'Žodžiai',
			learningTime: 'Mokymosi laikas',
			streak: 'Serija',
			streakRecord: 'Serijos rekordas',
			yourRecord: 'Tavo rekordas:',
			currentRecord: 'Dabartinis rekordas:',
			wordsInWeek: 'Savaitės žodžiai:',
		},
		bottom: {
			yourTutor: 'Tavo AI mokytojas',
			change: 'Keisti',
			logout: 'Atsijungti',
			FAQ: 'DUK',
			shareOpinion: 'Pasidalink savo nuomone',
			yourPlan: 'Tavo planas',
			hobby: 'Pomėgis',
			learningSetting: 'Mokymosi nustatymai',
			back: 'Atgal',
			dayTarget: 'Dienos tikslas',
			languageLevel: 'Kalbos lygis',
			changeYourLangLevel: 'Pakeisk savo kalbos lygį',
			pickNewTutor: 'Pasirink naują mokytoją',
			yourDecision: 'Tavo pasirinkimas paveiks pamokų stilių ir nuotaiką.',
			tutroChanged: 'Mokytojas pakeistas',
			error: 'Oi, kažkas negerai',
			englishLevelChanged: 'Kalbos lygis pakeistas',
			levelsOptions: [
				{
					name: 'Pradedantysis A1',
					description: 'Pradėk mokytis anglų kalbos',
					value: 'basic',
					borderRadius: '8px 8px 0 0',
				},
				{
					name: 'Pagrindinis A2',
					description:
						'Supranti pagrindinę informaciją paprastuose kasdieniuose pokalbiuose',
					borderRadius: '0',
					value: 'beginner',
				},
				{
					name: 'Vidutinis B1',
					description:
						'Gali palaikyti paprastus, bet aiškius pokalbius pažįstamomis temomis.',
					borderRadius: '0',
					value: 'intermediate',
				},
				{
					name: 'Pažengęs B2',
					description: 'Daugumoje situacijų gali bendrauti laisvai',
					borderRadius: '0',
					value: 'advanced',
				},
				{
					name: 'Ekspertas C1+',
					description: 'Efektyviai naudoji kalbą sudėtingose situacijose',
					value: 'expert',
					borderRadius: '0 0 8px 8px',
				},
			],
			changeDailyTarget: 'Keisti dienos mokymosi tikslą.',
			deletedFromFavorite: 'Pašalinta iš mėgstamiausių',
			addedToFavorite: 'Pridėta prie mėgstamiausių',
			lessonTime: [
				{
					name: 'Greita pamoka',
					dsecription: 'Puikus pasirinkimas greitam mokymuisi',
					time: '5 minutės',
					value: 'five_minutes',
					borderRadius: '8px 8px 0 0',
				},
				{
					name: 'Įprasta pamoka',
					dsecription: 'Subalansuota mokymosi patirtis',
					time: '10 minučių',
					value: 'ten_minutes',
					borderRadius: '0',
				},
				{
					name: 'Intensyvus mokymas',
					dsecription: 'Geriausias pasirinkimas motyvuotiems besimokantiesiems',
					time: '15 minučių',
					value: 'fifteen_minutes',
					borderRadius: '0 0 8px 8px',
				},
			],
			dailyTargetChanged: 'Dienos tikslas pakeistas!',
			pickIntresets: 'Pasirinkite bent 3 pomėgius.',
			activeTo: 'Jūsų planas galioja iki:',
			daysLeft: 'Liko jūsų plano dienų:',
			opinionSubtitle:
				'Nuolat tobuliname savo programėlę. Pasidalykite nuomone, ką norėtumėte pakeisti arba kas jums labiausiai patinka.',
			startTyping: 'Pradėkite rašyti',
			faq: 'DUK',
			send: 'Siųsti',
			withProblems: 'Jei turite klausimų ar problemų, susisiekite su mumis:',
			contactMail: 'contact@synthiaiapp.com',
			faqConfig: [
				{
					id: 1,
					question: 'Garsas neveikia.',
					answer:
						'Jei kyla problemų su garsu, pabandykite šiuos veiksmus:\n\nPatikrinkite naršyklės leidimus garsui.\n\nĮsitikinkite, kad jūsų įrenginio garsas yra įjungtas.\n\nPatikrinkite, ar garsiakalbiai / ausinės tinkamai prijungti.\n\nPeržiūrėkite sistemos garso nustatymus – ar kuri nors programėlė nėra nutildyta.\n\nPabandykite naudoti kitą įrenginį arba kreipkitės į techninę pagalbą.',
				},
				{
					id: 2,
					question: 'Nepavyksta įrašyti garso.',
					answer:
						'Jei negalite įrašyti garso, pabandykite šiuos veiksmus:\n\nPatikrinkite mikrofono leidimus naršyklėje.\n\nĮsitikinkite, kad mobilioji naršyklė turi prieigą prie mikrofono.\n\nĮsitikinkite, kad mikrofonas tinkamai prijungtas.\n\nPabandykite naudoti kitą įrenginį arba kreipkitės į techninę pagalbą.',
				},
				{
					id: 3,
					question: 'Ar galiu naudoti programėlę keliuose įrenginiuose?',
					answer:
						'Taip, galite prisijungti bet kuriame suderinamame įrenginyje ir mokytis sklandžiai.',
				},
				{
					id: 4,
					question: 'Ar galiu naudoti Synthi AI be interneto?',
					answer: 'Ne, Synthi AI reikia interneto ryšio veikimui.',
				},
				{
					id: 5,
					question: 'Kaip galiu pakeisti savo AI mokytoją?',
					answer:
						'Eikite į „Mokytojas“ skiltį Synthi AI nustatymuose. Peržiūrėkite ir pasirinkite kitą mokytoją.',
				},
				{
					id: 6,
					question: 'Kaip galiu atnaujinti prieigą pasibaigus laikotarpiui?',
					answer:
						'Pasibaigus galiojimui, prisijunkite ir atnaujinkite savo planą.',
				},
				{
					id: 7,
					question: 'Ar galiu gauti sąskaitą?',
					answer:
						'Parašykite adresu contact@synthiaiapp.com ir nurodykite savo PVM kodą bei įmonės duomenis.',
				},
				{
					id: 8,
					question: 'Kaip susisiekti su technine pagalba?',
					answer:
						'Rašykite el. paštu contact@synthiaiapp.com, nurodydami problemą ir informaciją apie įrenginį bei naršyklę.',
				},
			],
		},
		rules: 'taisykles',
		privacy: 'Privatumo politika',
		span: ' ir ',
	},
	welcome: {
		languagePicker: {
			title: 'Pasirink kalbą, kurią nori mokytis',
			next: 'Kitas',
			langToLearn: 'Mokoma kalba',
			successTitle: 'Mokoma kalba pakeista',
			config: [
				{
					label: 'Anglų',
					label2: 'Anglų kalba',
					labelInside: 'anglų kalbos',
					value: 'en',
				},
				{
					label: 'Vokiečių',
					label2: 'Vokiečių kalba',
					labelInside: 'vokiečių kalbos',
					value: 'de',
				},
				{
					label: 'Ispanų',
					label2: 'Ispanų kalba',
					labelInside: 'ispanų kalbos',
					value: 'es',
				},
				{
					label: 'Prancūzų',
					label2: 'Prancūzų kalba',
					labelInside: 'prancūzų kalbos',
					value: 'fr',
				},
				{
					label: 'Italų',
					label2: 'Italų kalba',
					labelInside: 'italų kalbos',
					value: 'it',
				},
			],
		},
		zeroScreen: {
			welcomeInApp: 'Sveiki atvykę į Synthi AI programėlę!',
			start: 'PRADĖTI',
			welcomeMobile: 'Sveiki atvykę',
			config: {
				chrome: {
					title: 'Įdiekite programėlę į savo Android įrenginį.',
					text1: 'Naršyklėje Chrome spustelėkite',
					text1bold: ' Nustatymai',
					image1: Android1,
					text2: 'Tada spustelėkite',
					text2bold: ' Pridėti prie pagrindinio ekrano',
					image2: Android2,
					text3: 'Viskas! Synthi AI dabar yra jūsų pagrindiniame ekrane',
					image3: Last,
				},
				safari: {
					title: 'Įdiekite programėlę į savo iOS įrenginį.',
					text1: 'Naršyklėje Safari spustelėkite',
					text1bold: ' Dalintis',
					image1: Ios1,
					text2: 'Tada spustelėkite',
					text2bold: ' Pridėti prie pagrindinio ekrano',
					image2: Ios2,
					text3: 'Viskas! Synthi AI dabar yra jūsų pagrindiniame ekrane',
					image3: Last,
				},
			},
		},
		firstScreen: {
			title: 'Pasirink savo mokytoją!',
			subtitle: 'Tavo pasirinkimas paveiks pamokų stilių ir nuotaiką.',
			next: 'TĘSTI',
		},
		secondScreen: {
			title: 'Koks tavo dabartinis {language} kalbos lygis?',
			config: [
				{
					name: 'Pradedantysis A1',
					description: 'Pradėk mokytis {language} kalbos.',
					value: 'basic',
				},
				{
					name: 'Pagrindinis A2',
					description:
						'Supranti pagrindinę informaciją paprastuose pokalbiuose',
					value: 'beginner',
				},
				{
					name: 'Vidutinis B1',
					description:
						'Gali vesti paprastus, bet suprantamus pokalbius žinomomis temomis.',
					value: 'intermediate',
				},
				{
					name: 'Pažengęs B2',
					description: 'Gali laisvai bendrauti daugumoje situacijų',
					value: 'advanced',
				},
				{
					name: 'Ekspertas C1+',
					description: 'Efektyviai naudoji kalbą sudėtingose situacijose',
					value: 'expert',
				},
			],
			next: 'TĘSTI',
		},
		thirdScreen: {
			title: 'Kokie tavo pomėgiai?',
			subtitle: 'Pasirink bent 3 pomėgius.',
			next: 'TĘSTI',
		},
		fourthScreen: {
			title: 'Kiek minučių per dieną nori mokytis?',
			subtitle: 'Pasirink savo dienos tikslą.',
			next: 'PRADĖKIME!',
			config: [
				{
					name: 'Greita pamoka',
					dsecription: 'Puikus pasirinkimas greitam mokymuisi',
					time: '5 minutės',
					value: 'five_minutes',
				},
				{
					name: 'Įprasta pamoka',
					dsecription: 'Subalansuota mokymosi patirtis',
					time: '10 minučių',
					value: 'ten_minutes',
				},
				{
					name: 'Intensyvus mokymas',
					dsecription: 'Geriausias pasirinkimas entuziastingiems mokiniams',
					time: '15 minučių',
					value: 'fifteen_minutes',
				},
			],
		},
	},
	features: {
		sceneV3: {
			twoToFiveMinutes: '2–5 minutės',
			twoToFiveMin: '2–5 min',
			role: 'Vaidmuo',
			description: 'Aprašymas',
			task: 'Užduotis',
			tasks: 'Užduotys',
			conversationStarted: 'Pokalbis prasidėjo',
			areYouSureYouWantToLeave: 'Ar tikrai nori išeiti?',
			youWillLoseProgress: 'prarasi pažangą',
			continue: 'Tęsti',
			leave: 'Išeiti',
			congratulations: 'Sveikiname!',
			yourAnswersWereClearAndLucid:
				'Tavo atsakymai buvo aiškūs, o sakiniai – taisyklingi.',
			finish: 'Baigti',
			howToUseScenes: 'Kaip naudotis scenomis?',
			buyingShoes: 'Batų pirkimas',
			clickSelectedScene: 'Spustelėk pasirinktą sceną, kad pradėtum mokymąsi.',
			clickToMarkAsFavorite: 'Spustelėk, kad pažymėtum sceną kaip mėgstamą.',
			youSeeWhenSceneIsDone: 'Pamatysi, kai scena bus baigta.',
			howLearningLookLike: 'Kaip atrodo mokymasis?',
			learningIsAbout:
				'Mokymasis – tai trumpas pokalbis pagal scenos aprašymą ir užduotis.',
			close: 'Uždaryti',
			clickToShareOpinion: 'Spustelėk, kad pasidalintum nuomone',
			clickToShownInstructions: 'Spustelėk, kad atidarytum instrukcijas',
			clickToCheckTasks: 'Spustelėk, kad peržiūrėtum užduotis',
			clickToHearAgain: 'Spustelėk, kad išgirstum dar kartą',
			clickToShowTranslation: 'Spustelėk, kad pamatytum vertimą',
			clickToShowHint: 'Spustelėk, kad pamatytum užuominą',
			clickToReportAProblem: 'Spustelėk, kad praneštum apie problemą',
			yourAnswerIsCorrect: 'Tavo atsakymas teisingas',
			clickToShowCorrectAnswer:
				'Spustelėk, kad pamatytum pataisytą atsakymą ir paaiškinimą',
			clickInTheTextInput: 'Spustelėk į teksto lauką, kad parašytum atsakymą',
			clickToStartRecording: 'Spustelėk, kad pradėtum įrašymą',
			taskCompleted: 'Užduotis atlikta',
			whenAllTasksAreDone:
				'Kai visos užduotys baigtos, scena laikoma užbaigta.',
			start: 'Pradėti',
			next: 'Kitas',
			skip: 'Praleisti',
			howToTalkInScenes: 'Kaip kalbėtis scenose?',
		},
	},
	features: {
		wordTrainer: {
			next: 'Kitas',
			yourSpeaking: 'Tavo tarimas',
			you: 'Tu',
			title: 'Žodžių treneris',
			errorMessage:
				'Oi ne! Įvyko klaida apdorojant tavo įrašą. Pabandyk dar kartą :)))',
			endScreenTitle: 'Puiku! 🌟🌟🌟',
			endScreenTopInfo: 'Tu jau išmokai visus',
			endScreenMiddleInfo: 'žodžius',
			endScreenBottomInfo: 'šiame lygyje.',
			endScreenText: 'Gali pradėti iš naujo arba pakeisti lygį nustatymuose.',
			endScreenBottomText: 'Pradėti iš naujo',
			endScreenEndText: 'Baigti',
			sesionScoreTitle: 'Puikiai sekasi! 🎉',
			sesionScoreSubTitle: 'Gerini savo tarimą',
			sesionScoreWord: 'Žodžiai',
			now: 'Dabar',
			sum: 'viso',
			continue: 'TĘSTI',
			areYouSureToEndLesson: 'Ar tikrai nori baigti pamoką?',
			speakingScore: 'Tarimo įvertinimas',
			GOOD_ARRAY: [
				'Šaunuolis!',
				'Tobula!',
				'Tu esi meistras!',
				'Puiku!',
				'Nuostabu!',
				'Genialu!',
			],
			BAD_ARRAY: [
				'Nepasiduok!',
				'Tu gali tai padaryti!',
				'Dar šiek tiek!',
				'Tęsk – esi beveik ten!',
				'Netrukus pavyks!',
				'Nieko tokio, bandyk dar kartą!',
			],
			OK_ARRAY: [
				'Esi teisingame kelyje!',
				'Labai arti!',
				'Vis geriau!',
				'Darai pažangą!',
				'Puikios pastangos!',
			],
			hold: 'Laikyk',
			holdText: 'mikrofoną ir ištark:',
			tutorial: {
				title: 'Kaip naudotis žodžių treneriu?',
				options: [
					{
						label: 'Spustelėk, kad išgirstum taisyklingą tarimą',
						icon: Micro,
					},
					{
						label: 'Laikyk nuspaudęs ir ištark žodį',
						icon: Voice,
					},
					{
						label: 'Spustelėk ir išgirsk savo įrašą, kad geriau išmoktum!',
						icon: Person,
					},
				],
				bottomText:
					'Reguliarus darbas su žodžių treneriu padės greičiau išmokti kalbą!',
				close: 'UŽDARYTI',
			},
		},
		topbar: {
			back: 'Atgal',
		},
		fotoMode: {
			welcome: {
				title: 'Atspėk paveikslėlį',
				subtitle:
					'Apibūdink tai, ką matai, kuo tiksliau pagal pasirinktą temą.',
				start: 'Pradėkime!',
			},
			info: {
				startTyping: 'Pradėk rašyti...',
				newTask: 'Nauja užduotis',
				send: 'Siųsti',
			},
		},
		flashcards: {
			title: 'Kortelės',
			subtitleTop:
				'Mokykis ir įsimink naujus žodžius naudodamas interaktyvias korteles.',
			addCategory: 'Pridėk savo kategoriją',
			subtitle: 'Įvesk kategorijos pavadinimą',
			type: 'įvesk kategoriją...',
			add: 'Pridėti',
			previous: 'Ankstesnė kortelė',
			task: 'Užduotis',
			changeLevel: 'Pakeisti lygį',
			dontKnow: 'Nežinau',
			know: 'Žinau',
			pickPairs: 'Pasirink poras',
			goodJob: 'Puikus darbas!',
			titleEnd: 'Tavo atsidavimas įspūdingas',
			subtitleEnd: 'Ar pasiruošęs naujiems iššūkiams?',
			repeat: 'Kartoti kategoriją',
			other: 'Pasirink kitą kategoriją',
			level: {
				title: 'Keisti kortelių lygį',
				beginner: 'Pradedantysis A1-A2',
				intermediate: 'Vidutinis B1-B2',
				advance: 'Pažengęs C1-C2',
				change: 'Keisti',
			},
		},
		scene: {
			title: 'Scenos',
			subtitle: 'Atlik sceną su AI mokytoju pasirinkta tema.',
			suggest: 'Pasiūlyk naują sceną',
			talk: 'Pokalbis',
			deletedFromFavorite: 'Pašalinta iš mėgstamiausių',
			addedToFavorite: 'Pridėta prie mėgstamiausių',
		},
		word: {
			title: 'Žodžiai',
			subtitle: 'Praturtink savo žodyną svarbiausiose srityse su AI mokytoju.',
			suggest: 'Pasiūlyk naują žodį',
			deletedFromFavorite: 'Pašalinta iš mėgstamiausių',
			addedToFavorite: 'Pridėta prie mėgstamiausių',
		},
	},
	cookie: {
		title: 'Ši svetainė naudoja slapukus',
		subtitle:
			'Naudojame slapukus turinio suasmeninimui, srauto analizei ir suasmenintai reklamai rodyti. Galite tvarkyti savo privatumo nustatymus. Daugiau informacijos rasite mūsų',
		link: 'Privatumo politikoje',
		accept: 'SUTINKU',
		denied: 'ATMESTI',
		manage: 'Tvarkyti',
		saveChanges: 'Išsaugoti pasirinkimus',
		necessary: {
			top: 'Būtini',
			text: 'Šie slapukai būtini tinkamam svetainės veikimui.',
		},
		functional: {
			top: 'Funkciniai',
			text: 'Šie išsaugo jūsų nustatymus, pvz., kalbą.',
		},
		analytical: {
			top: 'Analitiniai',
			text: 'Padeda mums matuoti srautą ir tobulinti svetainę.',
		},
		marketing: {
			top: 'Rinkodara',
			text: 'Leidžia rodyti suasmenintas reklamas ir taikyti remarketingą.',
		},
		personalization: {
			top: 'Turinio suasmeninimas',
			text: 'Leidžia pritaikyti svetainės turinį ir produktus pagal jūsų interesus.',
		},
	},
	talkingBar: {
		allowMicrofon: 'Prašome leisti naudotis mikrofonu',
		typeMessage: 'Rašyk žinutę...',
		record: 'Įrašyti',
		recording: 'Įrašoma',
	},
	hands: {
		giveUsInfo: 'Pasidalykite savo nuomone',
		thanksForGrading: 'Ačiū už atsiliepimą!',
		subtitle: 'Jūsų nuomonė mums svarbi!',
		subtitle2: 'Pasakykite mums, ką manote apie šią pamoką:',
		skip: 'Praleisti',
		send: 'Siųsti',
	},
	suggestConfig: {
		profile: {
			title: 'Pasidalykite savo nuomone!',
			subtitle:
				'Nuolat tobuliname savo programėlę. Parašykite, ką keistumėte arba kas labiausiai patiko.',
		},
		word: {
			title: 'Pasiūlyk naują žodį',
			subtitle: '',
		},
		scene: {
			title: 'Pasiūlyk naują sceną',
			subtitle: '',
		},
		startTyping: 'Pradėk rašyti',
		send: 'SIŲSTI',
		thx: 'Nuomonė išsiųsta! Ačiū!',
		error: 'Oi! Kažkas nepavyko',
	},
	checkout: {
		emailGuessText: 'Gal turėjai omenyje šį el. paštą?',
		leftTitle: 'Pasirink planą',
		rightTitle: 'Įveskite duomenis',
		subscribe: 'Prenumeruoti',
		total: 'Viso',
		currencySign: '€',
		accept: 'Sutinku ',
		space: ' ir ',
		email: 'El. paštas',
		placeHolderEmail: 'Įveskite savo el. paštą',
		rules: 'naudojimo sąlygomis',
		tos: 'privatumo politika',
		currency: 'eur',
		savePayments: 'Mokėjimus tvarko saugiai',
		planConfig: {
			price: 'Kaina',
			pre: 'Prisijunk prie',
			preColor: ' 50 000',
			post: 'naudotojų, kurie jau siekia savo tikslų',
			postColor: 'su Synthi AI',
		},
	},
	dailyV2: {
		conversation: {
			doYouWantContinueConversation:
				'Ar norite tęsti pokalbį ar pradėti naują?',
			continueConversation: 'Tęsti pokalbį',
			newConversation: 'Naujas pokalbis',
		},
		hint: {
			title: 'Patarimas',
			pick: 'Pasirinkimas',
			writeOrRecordAResponse: 'Parašykite arba įrašykite atsakymą',
			tryToSay: 'Pabandykite pasakyti',
		},
		feedback: {
			yourMessage: 'Tavo žinutė',
			goodMessage: 'Teisinga žinutė',
			explanation: 'Paaiškinimas',
		},
		tutorial: {
			title: 'Kaip naudotis pokalbiais?',
			skip: 'Praleisti',
			next: 'Kitas',
			start: 'Pradėti',
			screenConf: [ScreenOne, ScreenTwo, ScreenThree, ScreenFour],
			config: [
				[
					{
						title: 'Spustelėk norėdamas išjungti mokytojo balsą',
						image: VolumeUp,
					},
					{ title: 'Spustelėk, kad išreikštum nuomonę', image: HandsUp },
					{ title: 'Spustelėk, kad atidarytum vadovą', image: Tutorial },
				],
				[
					{ title: 'Spustelėk, kad pakartotum garsą', image: VolumeUpBlank },
					{
						title: 'Spustelėk, kad pamatytum vertimą',
						image: TranslationBlank,
					},
					{ title: 'Spustelėk, kad matytum patarimą', image: HintBlank },
					{
						title: 'Spustelėk, kad praneštum apie problemą',
						image: InfoBlank,
					},
				],
				[
					{ title: 'Tavo žinutė teisinga', image: GreenCircle },
					{
						title: 'Spustelėk, kad pamatytum pataisytą atsakymą',
						image: YellowCircle,
					},
				],
				[
					{ title: 'Spustelėk, kad parašytum žinutę', image: '' },
					{ title: 'Spustelėk, kad įrašytum žinutę', image: Microphone },
				],
			],
		},
	},
	problem: {
		title: 'Pranešti apie problemą',
		subtitle: 'Aprašykite problemą, susijusią su AI žinute',
		send: 'Siųsti',
		messageSend: 'Žinutė išsiųsta',
		error: 'Kažkas nepavyko, parašykite mums :)',
	},
	footer: {
		copy: 'Copyright©',
		privacy: 'Privatumo politika',
		rules: 'Naudojimo sąlygos',
		privacyUrl: '/privacy',
		rulesUrl: '/tos',
	},
};
